import React from "react"
import { Link } from "gatsby"
import { Wrapper } from "./Breadcrumb.styles"
import iconBreadcrumb from "../../images/icon-breadcrumbright.svg"

const Breadcrumb = ({ parent, pageTitle, parentLink }) => {
  return (
    <Wrapper>
      <Link to="/">Home</Link>
      <img alt="" src={iconBreadcrumb}></img>
      {parent ? (
        <>
          <Link to={parentLink}>{parent}</Link>
          <img alt="" src={iconBreadcrumb}></img>
        </>
      ) : null}
      <span className="page" to="#">
        {pageTitle}
      </span>
    </Wrapper>
  )
}

export default Breadcrumb
